// This file now re-exports the game module for backward compatibility
import PacmanGame from './game';

export default PacmanGame;